export function logger(...args) {
  // eslint-disable-next-line
  console.log(...args);
}
